import {
  JWT_TOKEN,
  USER_EMAIL_ID,
  USER_ID,
  USER_NAME,
  USER_ORG_ID,
} from "../Constants/StorageConstants";

/**
 * Extracts SSO parameters from URL and stores them in localStorage
 * @returns {boolean} true if SSO parameters were found and processed, false otherwise
 */
export const handleSSOCallback = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const id = urlParams.get("id");
    const name = urlParams.get("name");
    const orgId = urlParams.get("orgId");
    const emailId = urlParams.get("emailId");

    if (token && id) {
      localStorage.setItem(JWT_TOKEN, token);
      localStorage.setItem(USER_ID, id);
      if (name) localStorage.setItem(USER_NAME, name);
      if (orgId) localStorage.setItem(USER_ORG_ID, orgId);
      if (emailId) localStorage.setItem(USER_EMAIL_ID, emailId);
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
      return true;
    }
    return false;
  } catch (error) {
    console.error("Error processing SSO callback:", error);
    return false;
  }
};
